export default __webpack_public_path__ + "static/media/Promotion.a0624798.png";